import { useQuery } from '@tanstack/react-query';
import { ApiMapMarkerRepository } from '../../infrastructure/api/ApiMapMarkerRepository';
import { PropertySearchRequest } from '../../domain/valueObjects/PropertySearchRequest';

const repository = new ApiMapMarkerRepository();

export function useMarkerSearch(request: PropertySearchRequest) {
  const getQuery = useQuery({
    queryKey: [ 'markerSearch', request ],
    queryFn: () => repository.markerSearchRequest(request),
    enabled: !!request,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    markers: getQuery.data || [],
    error: getQuery.error || null,
    isLoading: getQuery.isLoading,
  };
}
